import * as React from "react";
import { maskMoneyInput } from "@/lib/moneyMask";

export type MoneyInputProps = Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  "type" | "inputMode" | "onChange" | "value"
> & {
  value: string;
  onChange: (value: string) => void;
};

export const MoneyInput = React.forwardRef<HTMLInputElement, MoneyInputProps>(
  ({ value, onChange, onPaste, placeholder = "0,00", className = "", disabled, readOnly, ...props }, ref) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange(maskMoneyInput(e.target.value));
    };

    const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
      e.preventDefault();
      onChange(maskMoneyInput(e.clipboardData.getData("text")));
      onPaste?.(e);
    };

    return (
      <div
        className={`flex h-10 w-full overflow-hidden rounded-md border border-input bg-background text-sm focus-within:outline-none disabled:cursor-not-allowed disabled:opacity-50 ${className}`}
      >
        <span className="flex h-full w-12 shrink-0 items-center justify-center border-r border-input bg-muted text-[inherit] text-foreground">
          R$
        </span>
        <input
          ref={ref}
          type="text"
          inputMode="numeric"
          autoComplete="off"
          value={value}
          onChange={handleChange}
          onPaste={handlePaste}
          placeholder={placeholder}
          disabled={disabled}
          readOnly={readOnly}
          className="min-w-0 flex-1 bg-transparent px-3 py-2 text-left text-[inherit] text-foreground outline-none placeholder:text-muted-foreground disabled:cursor-not-allowed"
          {...props}
        />
      </div>
    );
  },
);

MoneyInput.displayName = "MoneyInput";
